import React from "react";
import CommonModal from "../../components/Modal";
import { ModalProps } from "../../components/Modal/Modal.types";

const CampaignLimitWarningModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <CommonModal
      visible={open}
      background="#fff7e0"
      confirmText="Create campaign"
      cancelText="Cancel"
      iconType={"phishingManagerWarningModal"}
      modalContentTitle="You’re approaching your campaign limit"
      modalContentDesc={[
        "You are about to create your last available campaign under your current plan.",
        "Once this campaign is created, you won’t be able to create additional campaigns.",
        "To create more campaigns, please contact Customer Success to see available options."
      ]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default CampaignLimitWarningModal;